import { GatewayContact } from "@conformite/gateway";
import { useEntreprises } from "@src/store/store.entreprise";
import { useMe } from "@src/store/store.me";
import { Worksheet } from "exceljs";
import { assujettiExcelTemplate } from "./AssujettiExcelTemplate";

export function useAxesOptionnelsDisponibles(): boolean {
  const { me } = useMe();
  const { entreprisesBySiren } = useEntreprises();
  return (
    me?.contact.role === GatewayContact.ContactRoleUtilisateur.ADMINISTRATEUR &&
    Object.values(entreprisesBySiren ?? {}).some(
      (entreprise) => entreprise.conformiteOptionnelle
    )
  );
}

export function masquerColonnesAxesOptionnels(sheet: Worksheet) {
  Object.values(
    assujettiExcelTemplate.categories.axesOptionnels.columns
  ).forEach(({ col }) => {
    sheet.getColumn(col).hidden = true;
  });
}
